import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Modals.module.scss";
import Images from "@/utils/images.ts";
import {useTranslation} from "react-i18next";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import {KYCGeneralStatus} from "@/types_and_interfaces/types.ts";


const GoToKYC = () => {
    const [status, set_status] = useState<KYCGeneralStatus | undefined>(undefined);
    const effectRan = useRef<boolean>(false);
    const { t } = useTranslation();
    const callBackFunction = useRef<any>(null)
    
    const open_handle = ():boolean => {
        let open = false
        
        if(status === "UserStarted" || status === "Unknown"){
            open = true
        }
        
        return open
    }
    

    const openModal = (x: KYCGeneralStatus, callBack:any) => {
        set_status(x);
        if(typeof callBack == "function") {
            callBackFunction.current = callBack

            if(x !== "UserStarted" && x !== "Unknown") {
                callBack()
            }
        }
    };
    
    useEffect(() => {
        if (!effectRan.current) {
            eventEmitter.on(CommonClass.ModalEvents.GoToKYC, openModal);

            return () => {
                eventEmitter.off(CommonClass.ModalEvents.GoToKYC, openModal);
            };
        }
        
        effectRan.current = true;
    }, []);
    
    return (
        <ModalLayout
            className={st.go_ro_kyc}
            open={open_handle()}
            innerClassName={st.go_ro_kyc_inner}
            on_close_state={() => {
                set_status(undefined)
                if(typeof callBackFunction.current == "function") {
                    callBackFunction.current()
                }
            }}
            onAfterClose={() => {
                eventEmitter.emit(CommonClass.CustomEvents.show_promo_popups, true)
            }}
            removeClose
        >
            
            <>
                
                <div className={st.img_container}>
                    <img src={Images.common.hand_shake} alt="hand_shake" />
                </div>
                
                <div className={st.content}>
                    <div className={st.top}>
                        <strong>
                            {t("got_to_kyc")}
                        </strong>
                        
                        <span>
                            {status === "Unknown" ? t("want_to_kyc") : t("continue_kyc")}
                        </span>
                    </div>
                    
                    <div className={st.controllers}>
                        <Button
                            animated
                            onClick={() => {
                                set_status(undefined)
                                eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.KYC + "/1")
                            }}
                        >
                            <span>
                                {status === "Unknown" ? t("kyc_verification") : t("continue")}
                            </span>
                        </Button>
                        
                        <Button
                            className={st.transparent_button}
                            outlined
                            onClick={() => {
                                set_status(undefined)
                                if(typeof callBackFunction.current == "function") {
                                    callBackFunction.current()
                                }
                            }}
                        >
                            {t("latter")}
                        </Button>
                        
                    </div>
                    
                </div>
                
            </>
        
        </ModalLayout>
    )
}

export default GoToKYC